// Axios Mock Adapter
import '@/@fake-db/db'
import '@/libs/acl'
import '@/libs/clipboard'
import '@/libs/portal-vue'
import '@/libs/sweet-alerts'
import '@/libs/toastification'
// import '@/libs/tour'
import '@/libs/vue-select'
// 3rd party plugins
import '@axios'
import VueCompositionAPI from '@vue/composition-api'
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue'
import IdleVue from 'idle-vue'
import Vue from 'vue'
import { INACTIVITY_DURATION } from '@/helpers/constants'
import i18n from '@/libs/i18n'
import App from './App.vue'
// Global Components
import './global-components'
import router from './router'
import store from './store'
import './@core/styles/global.css'

const eventsHub = new Vue()
const { sessionTimeout } = store.getters['auth/getInstitution']

// Theme initialization function
// const initializeTheme = () => {

//   try {
//     // Get institution color from store if available
//     const primaryColor = store.getters['auth/getInstitution'].primaryColor
//     const secondaryColor = store.getters['auth/getInstitution'].secondaryColor

//     const cssVars = {
//       '--primary': primaryColor,
//       '--secondary': secondaryColor,
//     };

//     // Set CSS variables
//     Object.entries(cssVars).forEach(([key, value]) => {
//       document.documentElement.style.setProperty(key, value);
//     });

//   } catch (err) {
//     console.error('Error setting theme color:', err)
//   }
// }

// initializeTheme()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  // idleTime: 30 * 1000,
  idleTime: process.env.NODE_ENV !== 'development' ? (sessionTimeout || 100) * 60000 : INACTIVITY_DURATION,
  startAtIdle: false,
})

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
